//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input.vue";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConditionMultiValueInput",
  components: {
    MaterialInput,
    DatepickerInput
  },
  props: {
    valueType: {
      type: String,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    conditionName: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    $v: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    valueTypeIsNumber() {
      return this.valueType === "number";
    },
    valueTypeIsDate() {
      return this.valueType === "date";
    }
  },
  methods: {
    handleMinChange(val) {
      const value = {
        id: "1",
        value: val || ""
      };
      this.$emit("change", value);
    },
    handleMaxChange(val) {
      const value = {
        id: "2",
        value: val || ""
      };
      this.$emit("change", value);
    }
  }
});